import React from 'react';
import CTABlock from '../components/CTABlock';
import DemoBanner from '../components/DemoBanner';

const Over = () => {
  return (
    <div className="min-h-screen py-16 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8 text-center">Over vacature.ai</h1>
        
        <div className="prose prose-lg mx-auto text-gray-600 mb-16">
          <p className="lead text-xl mb-6">
            Vacature.ai is gebouwd voor mensen die geen zin hebben in eindeloos scrollen. We combineren praktische hulpmiddelen (AI-capabilities) met heldere uitleg (kennisbank) — zodat jij sneller keuzes maakt en sterker solliciteert.
          </p>
          <p className="mb-6">
            Onze missie is simpel: minder ruis, meer richting. Solliciteren is al stressvol genoeg. Wij geloven dat technologie je kan helpen om sneller de juiste match te vinden en jezelf beter te presenteren.
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-lg">
            <h3 className="font-bold text-blue-900 mb-2">Privacy & Browser AI</h3>
            <p className="text-blue-800">
              Deze tools werken direct in je browser. Geen account. Geen data-opslag. Je persoonlijke gegevens en teksten worden lokaal verwerkt en nooit opgeslagen op onze servers.
            </p>
          </div>
        </div>

        <CTABlock 
          title="Heb je een vraag?" 
          description="Neem contact met ons op voor feedback of ideeën." 
          buttonText="Contact opnemen" 
          buttonLink="/contact" 
        />
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-400">
            Of mail direct: <a href="mailto:vacature.ai@gmail.com" className="hover:text-brand-orange transition-colors">vacature.ai@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Over;